import React from "react";
import { observer } from "mobx-react";
import Button from "Components/common/Button";
import { openAddLinkedInAccountPopup } from "./common/addLinkedInAccountTrigger";

const ConnectedLinkedInButton = observer((props = {}) => {
  return (
    <div className="dropdownBtn">
      <Button
        id="ConnectedLinkedInButton"
        name="ConnectedLinkedInButton"
        btnText="Connect Account"
        type="button"
        className={`ConnectedLinkedInButton`}
        click={openAddLinkedInAccountPopup}
      />
    </div>
  );
});

export { ConnectedLinkedInButton };
export default ConnectedLinkedInButton;
